import React, { useEffect, useMemo, useState } from 'react';
import { Box, Typography } from '@mui/material';

const ROUTE_EVENT_CODES = new Set(['DSP', 'DISPATCHED', 'ORDER_DISPATCHED', 'IN_ROUTE']);

const parseDateMs = (value) => {
  const date = value ? new Date(value) : null;
  const time = date ? date.getTime() : NaN;
  return Number.isFinite(time) ? time : null;
};

const getRouteStartedAtMs = (order = {}) => {
  const routeEvents = (Array.isArray(order.history) ? order.history : [])
    .filter((event) => (
      ROUTE_EVENT_CODES.has(String(event?.code || '').toUpperCase()) ||
      ROUTE_EVENT_CODES.has(String(event?.fullCode || '').toUpperCase())
    ))
    .map((event) => parseDateMs(event.createdAt || event.updatedAt))
    .filter((time) => time !== null)
    .sort((a, b) => b - a);

  return routeEvents[0] || parseDateMs(order.updatedAt) || parseDateMs(order.createdAt) || Date.now();
};

const formatElapsed = (seconds) => {
  const safeSeconds = Math.max(0, seconds);
  const hours = Math.floor(safeSeconds / 3600);
  const minutes = Math.floor((safeSeconds % 3600) / 60);
  const remainingSeconds = safeSeconds % 60;

  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  }

  return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
};

const getRouteTimerLevel = (elapsedSeconds) => {
  if (elapsedSeconds >= 60 * 60) return 'critical';
  if (elapsedSeconds >= 30 * 60) return 'danger';
  if (elapsedSeconds >= 20 * 60) return 'orange';
  if (elapsedSeconds >= 10 * 60) return 'warning';
  return 'normal';
};

const RouteElapsedTimer = ({ order }) => {
  const routeStartedAtMs = useMemo(() => getRouteStartedAtMs(order), [order]);
  const [elapsedSeconds, setElapsedSeconds] = useState(() => (
    Math.floor((Date.now() - routeStartedAtMs) / 1000)
  ));

  useEffect(() => {
    const updateElapsed = () => {
      setElapsedSeconds(Math.floor((Date.now() - routeStartedAtMs) / 1000));
    };

    updateElapsed();
    const timer = setInterval(updateElapsed, 1000);
    return () => clearInterval(timer);
  }, [routeStartedAtMs]);

  const level = getRouteTimerLevel(elapsedSeconds);

  return (
    <Box className={`pedidos-route-timer pedidos-route-timer--${level}`}>
      <Typography variant="caption" className="pedidos-route-timer__text">
        {formatElapsed(elapsedSeconds)}
      </Typography>
    </Box>
  );
};

export default RouteElapsedTimer;
